<template>
  <div class="znty-touzituijian">

    <!-- 页面标题 -->
    <div class="recommend-header">
      <div class="header-title">
        基于您的风险等级和配置建议，投顾助手为您推荐以下具体产品：
      </div>
    </div>

    <!-- 风险等级和配置信息 -->
    <div class="risk-config-section">
      <div class="risk-level">
        R1 保守型：股票类10% +债券类40% +现金类50%
      </div>
    </div>

    <!-- 主内容区域 -->
    <template v-if="status == 1">
      <div class="recommend-content">
        <!-- 产品列表 -->
        <div class="product-list">
          <div class="product-item" v-for="product in productList" :key="product.id">
            <div class="product-icon" :style="{ color: product.color }">{{ product.icon }}</div>
            <div class="product-info">
              <div class="product-name">{{ product.name }}</div>
              <div class="product-details">
                <span class="yield">年化收益: {{ product.yield }}%</span>
                <span class="weight">权重{{ product.weight }}%</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 饼图 -->
        <div class="chart-section">
          <div class="chart-container" ref="chartContainer"></div>
        </div>
      </div>

      <!-- 时间提示 -->
      <div class="time-note">
        （年化收益最新更新至2025/8/11日，点击产品可查看产品走势图）
      </div>

      <!-- 按钮 -->
      <div class="action-button">
        <button class="invest-btn" @click="changeStatus">构建投资组合</button>
      </div>
    </template>


    <template v-if="status == 2">
      <div class="kline-top">
        <div class="kline-top-left">
          业绩走势
        </div>
        <div class="kline-top-right" @click="closeKline">
          <i class="el-icon-error"></i>
          <span>关闭</span>
        </div>
      </div>
      <!-- 股票走势K线图 -->
      <div class="kline-chart-wrapper">
        <!-- K线图容器 -->
        <div class="kline-chart-container" ref="klineChartContainer"></div>
        <!-- 时间范围切换按钮 -->
        <div class="time-range-buttons">
          <button v-for="range in ['近1月', '近3月', '近6月', '近1年']" :key="range"
                  :class="['range-btn', { active: selectedRange === range }]" @click="switchTimeRange(range)">
            {{ range }}
          </button>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
// 引入echarts用于绘制饼图
import * as echarts from 'echarts'

export default {
  name: 'touzituijian',
  components: {},
  props: {},
  data () {
    return {
      status: 1,//1：推荐产品 2：构建组合
      selectedRange: '近1年', // 默认选中的时间范围
      // 模拟的K线图数据
      klineData: {
        '近1月': this.generateKlineData(30),
        '近3月': this.generateKlineData(90),
        '近6月': this.generateKlineData(180),
        '近1年': this.generateKlineData(365)
      },
      // 产品列表数据
      productList: [
        {
          id: 1,
          icon: '▶',
          color: '#1549F3',
          name: '天弘余额宝货币基金',
          yield: 2.5,
          weight: 20
        },
        {
          id: 2,
          icon: '▶',
          color: '#36CBCB',
          name: '招商招钱宝货币A',
          yield: 2.8,
          weight: 30
        },
        {
          id: 3,
          icon: '▶',
          color: '#FFB700',
          name: '易方达增强回报债券A',
          yield: 4.2,
          weight: 20
        },
        {
          id: 4,
          icon: '▶',
          color: '#9966FF',
          name: '南方宝元债券A',
          yield: 4.0,
          weight: 20
        },
        {
          id: 5,
          icon: '▶',
          color: '#1549F3',
          name: '华夏沪深300ETF联接A',
          yield: 6.5,
          weight: 10
        }
      ],
      // 饼图数据
      chartData: [
        {
          value: 20,
          name: '天弘余额宝货币基金',
          itemStyle: { color: '#1549F3' }
        },
        {
          value: 30,
          name: '招商招钱宝货币A',
          itemStyle: { color: '#36CBCB' }
        },
        {
          value: 20,
          name: '易方达增强回报债券A',
          itemStyle: { color: '#FFB700' }
        },
        {
          value: 20,
          name: '南方宝元债券A',
          itemStyle: { color: '#9966FF' }
        },
        {
          value: 10,
          name: '华夏沪深300ETF联接A',
          itemStyle: { color: '#1549F3' }
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () {
    // 初始化饼图
    this.initChart()

  },
  methods: {
    closeKline () {
      this.status = 1
      this.$nextTick(() => {
        // 初始化饼图
        this.initChart()
      })
    },

    changeStatus () {
      this.status = 2
      this.$nextTick(() => {
        // 初始化K线图
        this.initKlineChart()
      })
    },

    // 生成模拟的K线图数据
    generateKlineData (days) {
      const data = [];
      const baseDate = new Date();

      // 初始值设置
      let fundValue = 100;
      let avgValue = 100;
      let indexValue = 100;

      // 模拟一年的数据，开始时间为当前时间前一年
      for (let i = days; i >= 0; i--) {
        const date = new Date(baseDate.getTime() - i * 24 * 60 * 60 * 1000);
        const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

        // 生成随机波动，本基金波动较大
        const fundChange = (Math.random() - 0.48) * 5;
        const avgChange = (Math.random() - 0.49) * 2;
        const indexChange = (Math.random() - 0.49) * 2;

        fundValue += fundChange;
        avgValue += avgChange;
        indexValue += indexChange;

        // 计算百分比
        const fundPercent = ((fundValue / 100) - 1) * 100;
        const avgPercent = ((avgValue / 100) - 1) * 100;
        const indexPercent = ((indexValue / 100) - 1) * 100;

        data.push([
          dateStr,
          Number(fundPercent.toFixed(2)),
          Number(avgPercent.toFixed(2)),
          Number(indexPercent.toFixed(2))
        ]);
      }

      return data;
    },

    // 切换时间范围
    switchTimeRange (range) {
      this.selectedRange = range;
      this.initKlineChart();
    },

    // 初始化K线图
    initKlineChart () {
      if (!this.$refs.klineChartContainer) return;

      const chart = echarts.init(this.$refs.klineChartContainer);
      const data = this.klineData[this.selectedRange];

      // 提取x轴日期数据
      const dates = data.map(item => item[0]);

      // 提取三类数据
      const fundData = data.map(item => item[1]);
      const avgData = data.map(item => item[2]);
      const indexData = data.map(item => item[3]);

      const option = {
        backgroundColor: 'transparent',
        // 添加时间范围切换按钮
        legend: {
          data: ['本基金', '同类均值', '沪深300'],
          textStyle: {
            color: '#b8c4e0'
          },
          top: 0,
          right: 0
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function (params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(param => {
              const color = param.color;
              const value = param.value;
              const sign = value >= 0 ? '+' : '';
              result += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>`;
              result += `${param.seriesName}: <span style="color:${value >= 0 ? '#36CBCB' : '#ff4d4f'}">${sign}${value}%</span><br/>`;
            });
            return result;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLabel: {
            color: '#b8c4e0',
            rotate: 45
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          },
          // 启用拖拽缩放
          scale: true,
          axisPointer: {
            label: {
              formatter: function (params) {
                return params.value;
              }
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '收益率(%)',
          nameTextStyle: {
            color: '#b8c4e0'
          },
          axisLabel: {
            color: '#b8c4e0',
            formatter: '{value}%'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 100,
            height: 20,
            textStyle: {
              color: '#b8c4e0'
            },
            handleStyle: {
              color: '#1549F3'
            },
            fillerColor: 'rgba(21, 73, 243, 0.2)'
          }
        ],
        series: [
          {
            name: '本基金',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: '#1549F3'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(21, 73, 243, 0.3)' },
                { offset: 1, color: 'rgba(21, 73, 243, 0)' }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: fundData
          },
          {
            name: '同类均值',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: '#FF7D00'
            },
            emphasis: {
              focus: 'series'
            },
            data: avgData
          },
          {
            name: '沪深300',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: '#FFB700'
            },
            emphasis: {
              focus: 'series'
            },
            data: indexData
          }
        ]
      };

      chart.setOption(option);

      // 响应式调整
      window.addEventListener('resize', () => {
        chart.resize();
      });
    },

    // 初始化饼图
    initChart () {
      if (!this.$refs.chartContainer) return

      const chart = echarts.init(this.$refs.chartContainer)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}%'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '资产配置',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#0a192f',
              borderWidth: 2
            },
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold',
                color: '#fff'
              }
            },
            labelLine: {
              show: false
            },
            data: this.chartData
          }
        ]
      }

      chart.setOption(option)

      // 响应式调整
      window.addEventListener('resize', () => {
        chart.resize()
      })
    }
  }
}
</script>

<style scoped lang="less">
.znty-touzituijian {
  color: #fff;
  padding: 20px;
  box-sizing: border-box;
  // min-height: 100vh;

  // 页面标题样式
  .recommend-header {
    margin-bottom: 30px;

    .header-title {
      font-size: 20px;
      color: #fff;
      line-height: 1.6;
      text-align: center;
      font-weight: 500;
    }
  }

  // 风险等级样式
  .risk-config-section {
    margin-bottom: 30px;
    text-align: center;

    .risk-level {
      font-size: 24px;
      color: #4568F7;
      font-weight: bold;
      padding: 15px;
      background: rgba(21, 73, 243, 0.1);
      border-radius: 12px;
      border: 1px solid rgba(21, 73, 243, 0.3);
      display: inline-block;
    }
  }

  // 主内容区域
  .recommend-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    gap: 40px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 20px;
    }

    // 产品列表
    .product-list {
      flex: 1;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 16px;
      padding: 25px;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(21, 73, 243, 0.2);

      .product-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        &:last-child {
          border-bottom: none;
        }

        .product-icon {
          font-size: 16px;
          margin-right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .product-info {
          flex: 1;

          .product-name {
            font-size: 16px;
            color: #fff;
            margin-bottom: 5px;
            font-weight: 500;
          }

          .product-details {
            display: flex;
            gap: 20px;
            font-size: 14px;
            color: #b8c4e0;

            .yield {
              color: #36CBCB;
            }

            .weight {
              color: #FFB700;
            }
          }
        }
      }
    }

    // 饼图区域
    .chart-section {
      flex: 1;

      .chart-container {
        width: 100%;
        height: 400px;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 16px;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(21, 73, 243, 0.2);
      }
    }
  }

  // 时间提示
  .time-note {
    text-align: center;
    font-size: 14px;
    color: #8a99c0;
    margin-bottom: 30px;
    font-style: italic;
  }

  // 操作按钮
  .action-button {
    text-align: center;

    .invest-btn {
      padding: 14px 60px;
      font-size: 18px;
      font-weight: bold;
      background: #1549F3;
      color: #fff;
      border: none;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);

      &:hover {
        background: #1549F3;
        transform: translateY(-3px);
        box-shadow: 0 6px 20px rgba(21, 73, 243, 0.5);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .kline-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;

    .kline-top-left {
      background: #1549F3;
      color: #fff;
      border-color: #1549F3;
      box-shadow: 0 2px 8px rgba(21, 73, 243, 0.3);
      padding: 8px 20px;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      font-weight: 500;
    }

    .kline-top-right {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      i {
        color: red;
      }
    }
  }

  // K线图相关样式
  .kline-chart-wrapper {
    width: 100%;
    margin-top: 20px;

    // 时间范围按钮
    .time-range-buttons {
      display: flex;
      gap: 10px;
      margin-top: 20px;
      justify-content: center;

      .range-btn {
        padding: 8px 20px;
        background: rgba(0, 0, 0, 0.3);
        color: #b8c4e0;
        border: 1px solid rgba(21, 73, 243, 0.2);
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s ease;
        font-size: 14px;

        &:hover {
          background: rgba(21, 73, 243, 0.2);
          color: #fff;
        }

        &.active {
          background: #1549F3;
          color: #fff;
          border-color: #1549F3;
          box-shadow: 0 2px 8px rgba(21, 73, 243, 0.3);
        }
      }
    }

    // K线图容器
    .kline-chart-container {
      width: 100%;
      height: 500px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 16px;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(21, 73, 243, 0.2);
      padding: 20px;
      box-sizing: border-box;
    }
  }
}
</style>
